<template>
 <view>
    <HeaderPage/>
    <div class="container">
        <div class="row">
            <div class="col-md-8 news_page_box">
                <div class="path">
                    <i class="fa fa-television"></i>当前位置： 专题
                </div>
                <div class="coloum_list">
                    <div class="news-a" v-for="(item,index) in specialList" :key="index">
                        <span class="date">{{formatTimestamp(item.ctime)}}</span>
                        <router-link :to="'/zhuanti/node_'+item.basic_id+'.html'" target="_blank">{{item.title}}</router-link>
                        <div class="clear"></div>
                    <div class="line" v-if="(index + 1) % 10 == 0"></div> 
                    </div>
                </div>
                <div style="text-align:center; position: absolute; top:25%; width: 100%;" v-if="specialList.length <= 0">
                    <div><img src="../../assets/images/nodatamsg.png"  style="width:350px; height:auto;"></div>
                    <div style="color:#999999; margin-top:10px;">暂无相关数据,请稍后重试~</div>
                </div>
                <div id="loading-mask" v-if="isLodding == 1">
                    <div class="loading-wrapper">
                        <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
                    </div>
                </div>
                <pageRows
                @change="changePage"
                :current="pagination.p"
                :pageSize="pagination.pageSize"
                :total="totalNum"
                :hideOnSinglePage="hideOnSinglePage"
                :showQuickJumper="true"
                :showTotal="true"
                placement="center"
                v-if="pagination && totalNum" />
            </div>
            <div class="col-md-4 news_page_right">
                <RightPage/>
            </div>
        </div>
    </div>
</view>
</template>
<script>
    import { post } from '@/request'; 
    import HeaderPage from '@/components/HeaderUnit.vue'
    import RightPage from '@/components/RightUnit.vue'
    import pageRows from '@/components/PaginationUnit.vue'
    export default {
        components: {
            HeaderPage,
            RightPage,
            pageRows
        },
        data() {
            return {
                isLodding: 1,
                totalNum: 0,
                specialList: [],
                hideOnSinglePage: true,
                pagination: {
                    pageSize: 25,
                    p: 1
                }
            }
        },
        mounted(){
            this.getNewsList(1)
        },
        created() {
        },
        methods: {
            formatTimestamp(timestamp) {  
                return this.$formatTimeAgo(timestamp); // 调用全局方法  
            }, 
            changePage (pager) { // 分页器回调
                //console.log(pager)
                this.$emit('change', pager)
                this.getNewsList(pager.page)
            },
            goSpecialList(basicid,title) {  
                this.$router.push({ 
                    name: 'special', 
                    params: { id: basicid+'.html' },
                    query: { title: title } 
                });  
            },  
            async getNewsList(e) {  
                let that = this
                that.isLodding = 1
                let pagenum = e
                try {  
                    const postData = {'page': pagenum,'length': 25 };  
                    const response = await post('special', postData);  
                    //console.log(response)
                    that.isLodding = 0
                    document.title = '专题-'+JSON.parse(localStorage.getItem('websiteInfo')).websiteName
                    that.specialList = response.data
                    that.totalNum = response.total
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
        },
    }
</script>
  